<template>
  <Result />
</template>

<script>
import Result from '@/views/result.vue'

export default {
  name: 'NotFound',
  components: {
    Result
  },
  props: {},
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {},
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
